"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUnitLabel = exports.getFieldDate = void 0;
var _types = require("./types");
var getFieldDate = function getFieldDate(fieldName, formData) {
  var _a;
  var value = (_a = formData === null || formData === void 0 ? void 0 : formData[fieldName]) === null || _a === void 0 ? void 0 : _a.value;
  return !value ? undefined : new Date(String(value));
};
exports.getFieldDate = getFieldDate;
var unitMap = new Map([[_types.DateDiffUnits.Seconds, "seconds"], [_types.DateDiffUnits.Minutes, "minutes"], [_types.DateDiffUnits.Hours, "hours"], [_types.DateDiffUnits.Days, "days"], [_types.DateDiffUnits.Weeks, "weeks"], [_types.DateDiffUnits.Years, "years"]]);
var getUnitLabel = function getUnitLabel(propsI18n, formI18n, defaultI18n, diff, diffUnit) {
  var _a, _b, _c, _d, _e, _f;
  if (propsI18n === void 0) {
    propsI18n = {};
  }
  if (formI18n === void 0) {
    formI18n = {};
  }
  if (!diffUnit || !unitMap.has(diffUnit)) {
    return "";
  }
  var unitKey = unitMap.get(diffUnit);
  var numberKey = diff === 1 ? "singular" : "plural";
  return !unitKey ? "" : String(((_b = (_a = propsI18n === null || propsI18n === void 0 ? void 0 : propsI18n.units) === null || _a === void 0 ? void 0 : _a[unitKey]) === null || _b === void 0 ? void 0 : _b[numberKey]) || ((_d = (_c = formI18n === null || formI18n === void 0 ? void 0 : formI18n.units) === null || _c === void 0 ? void 0 : _c[unitKey]) === null || _d === void 0 ? void 0 : _d[numberKey]) || ((_f = (_e = defaultI18n === null || defaultI18n === void 0 ? void 0 : defaultI18n.units) === null || _e === void 0 ? void 0 : _e[unitKey]) === null || _f === void 0 ? void 0 : _f[numberKey]));
};
exports.getUnitLabel = getUnitLabel;